export default __webpack_public_path__ + "static/media/ampbilogo.0cdaa6d1.svg";